export function ToolbarMenuMobile() {
  // Toolbar menu removed - navigation is handled by sidebar
  return null;
}